import { Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Message, SpinnerService} from 'shared-components';
import { CultivosService } from '../../../../services/cultivos.service';

@Component({
    selector: 'app-cultivo-productor',
    templateUrl: './cultivo-productor.component.html'
})
export class CultivoProductorComponent {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    public listaCultivosProductor;

    public editables;
    public new = false;
    public newEditModal = false;
    public deleteModal = false;
    public toCloseSpinner = 0;

    private _filters;
    public cultivoProductor;
    public desFinca;
    public _cultivoId;
    public productoresList;

    public showError: boolean;
    public showWarning: boolean;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0; // La paginación en back empieza por 0
    public totalItems: number;
    public readonly visiblePages = 3;

    public orderBy: string;
    public firtstime = true;
    public idColumn;

    //@Output() refreshCultivo = new EventEmitter<boolean>();

    @Input() paisId;
    @Input() campanyaHabilitada: boolean;
    @Input() set denominacionId(denominacionId: any) {
        this._filters = {
            paisIdAcceso: this.paisId,
            denominacionIdAcceso: denominacionId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getProductores(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.productoresList = resp.lista;
            this.productoresList.forEach(a=> {
              const productor = this.listaCultivosProductor.find(b=>b.productorId == a.id);
              if(productor) productor.desProductor = a.des;
            });
        });
    }
    @Input() set productoresCultivo(cultivoId: any) {
        this._cultivoId = cultivoId;
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getProductoresByCultivoId(this._cultivoId).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.listaCultivosProductor = resp;
        });
    }

    @Output() pushMessage = new EventEmitter<string>();

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _cultivosService: CultivosService,
        private readonly _sessionContext: SessionContextService
    ) {}

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
    }

    public refresh(value) {
        this.editables = '';
        this.newEditModal = false;
        if (value) {
            this.reload();
        }
    }

    public reload() {
        this.new = false;
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getProductoresByCultivoId(this._cultivoId).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.listaCultivosProductor = resp;
            //this.refreshCultivo.emit(true);
        });
    }

    public editableChanged(cultivoProductor) {
        this.editables = cultivoProductor;
        this.new = false;
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
          this._spinnerService.hideSpinner();
        }
    }

    public toOrderBy(id: any) {
      this.idColumn = id;
      if (this.firtstime) {
          this.orderBy = 'desc';
          this.firtstime = false;
      } else {
          if (this.orderBy === 'desc') {
              this.orderBy = 'asc';
          } else if (this.orderBy === 'asc') {
              this.orderBy = 'desc';
          }
      }
    }

    public getIcon(id: any) {
      let iconClass = 'fa fa-sort';
      if (id === this.idColumn) {
          iconClass = this.orderBy === 'desc' ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

}
